import { render, staticRenderFns } from "./TranslationWorkbook.vue?vue&type=template&id=486cb652&"
import script from "./TranslationWorkbook.vue?vue&type=script&lang=js&"
export * from "./TranslationWorkbook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports